import { ChainRpcProps } from "types/baseType"

const chainRpcs: {[key: string]: ChainRpcProps} = {
    // FSN
    "32659":{
        "rpcUrl":"https://mainnet.fusionnetwork.io",
        "scanUrl":"https://fsnscan.com",
        "address": "0x80d5DEB2b3F3Bf673D3B4834fc17D51519df7B28",
        "swapAddress": "0xAf5A8CbCCE58267D05577a560D04b51D46dCc124"
    },
    // ETH
    "1":{
        "rpcUrl":"https://rpc.ankr.com/eth",
        "scanUrl":"https://etherscan.io",
        "address": "0x43e9f7ca4aeacd67a7ac4a275cee7bc8af601be4",
        "swapAddress": ""
    },
    // BNB
    "56":{
        "rpcUrl":"https://rpc.ankr.com/bsc",
        "scanUrl":"https://bscscan.com",
        "address": "0xcEeC9BBD56e7b083d4e0560982E0EeD28F0882D2",
        "swapAddress": "0xBFFcA20712e0906D1ef74F3E0A7cBE050AA6228A"
    },
    // HT
    "128":{
        "rpcUrl":"https://http-mainnet.hecochain.com",
        "scanUrl":"https://www.hecoinfo.com/en-us",
        "address": "",
        "swapAddress": ""
    },
    // OKC
    "66":{
        "rpcUrl":"https://exchainrpc.okex.org",
        "scanUrl":"https://www.oklink.com/en/okc",
        "address": "",
        "swapAddress": ""
    },
    // AVAXC
    "43114":{
        "rpcUrl":"https://rpc.ankr.com/avalanche",
        "scanUrl":"https://snowtrace.io",
        "address": "0x43e9f7ca4aeacd67a7ac4a275cee7bc8af601be4",
        "swapAddress": ""
    },
    // FTM
    "250":{
        "rpcUrl":"https://rpc.ankr.com/fantom",
        "scanUrl":"https://ftmscan.com",
        "address": "0x43e9f7ca4aeacd67a7ac4a275cee7bc8af601be4",
        "swapAddress": ""
    },
    // ETC
    "61":{
        "rpcUrl":"https://www.ethercluster.com/etc",
        "scanUrl":"https://www.oklink.com/en/etc",
        "address": "0x43e9f7ca4aeacd67a7ac4a275cee7bc8af601be4",
        "swapAddress": ""
    },
    // ETHW
    "10001":{
        "rpcUrl":"https://mainnet.ethereumpow.org",
        "scanUrl":"https://www.oklink.com/en/ethw",
        "address": "",
        "swapAddress": ""
    },
    // ETHF
    "513100":{
        "rpcUrl":"https://rpc.etherfair.org",
        "scanUrl":"https://www.oklink.com/en/ethf",
        "address": "",
        "swapAddress": ""
    },
    // FUSE
    "122":{
        "rpcUrl":"https://fuse-pokt.nodies.app",
        "scanUrl":"https://explorer.fuse.io/",
        "address": "0x43e9f7ca4aeacd67a7ac4a275cee7bc8af601be4",
        "swapAddress": ""
    },
    // POLYGON
    "137":{
        "rpcUrl":"https://rpc.ankr.com/polygon",
        "scanUrl":"https://polygonscan.com",
        "address": "0x43e9f7ca4aeacd67a7ac4a275cee7bc8af601be4",
        "swapAddress": ""
    },
    // AURORA
    "1313161554":{
        "rpcUrl":"https://mainnet.aurora.dev",
        "scanUrl":"https://aurorascan.dev",
        "address": "0x43e9f7ca4aeacd67a7ac4a275cee7bc8af601be4",
        "swapAddress": ""
    },
    // CAD
    "256256": {
        "rpcUrl":"https://mainnet.block.caduceus.foundation",
        "scanUrl":"https://mainnet.scan.caduceus.foundation/",
        "address": "",
        "swapAddress": ""
    },
    // METIS
    "1088":{
        "rpcUrl":"https://andromeda.metis.io/?owner=1088",
        "scanUrl":"https://andromeda-explorer.metis.io",
        "address": "0x43e9f7ca4aeacd67a7ac4a275cee7bc8af601be4",
        "swapAddress": ""
    },
    // CIC
    "1353":{
        "rpcUrl":"https://xapi.cicscan.com",
        "scanUrl":"https://cicscan.com/",
        "address": "",
        "swapAddress": ""
    },
    // RSK
    "30":{
        "rpcUrl":"https://public-node.rsk.co",
        "scanUrl":"https://explorer.rsk.co",
        "address": "0x43e9f7ca4aeacd67a7ac4a275cee7bc8af601be4",
        "swapAddress": ""
    },
    // TARA
    "841":{
        "rpcUrl":"https://rpc.mainnet.taraxa.io",
        "scanUrl":"https://mainnet.explorer.taraxa.io",
        "address": "",
        "swapAddress": ""
    },
    // KLAY
    "8217":{
        "rpcUrl":"https://cypress.fandom.finance/archive",
        "scanUrl":"https://scope.klaytn.com",
        "address": "0x43e9f7ca4aeacd67a7ac4a275cee7bc8af601be4",
        "swapAddress": ""
    },
    // CRO
    "25":{
        "rpcUrl":"https://evm-cronos.crypto.org",
        "scanUrl":"https://cronoscan.com",
        "address": "",
        "swapAddress": ""
    },
    // CANTO
    "7700":{
        "rpcUrl":"https://canto.slingshot.finance",
        "scanUrl":"https://evm.explorer.canto.io",
        "address": "0x43e9f7ca4aeacd67a7ac4a275cee7bc8af601be4",
        "swapAddress": ""
    },
    // CORE
    "1116":{
        "rpcUrl":"https://rpc.coredao.org",
        "scanUrl":"https://scan.coredao.org",
        "address": "0x43e9f7ca4aeacd67a7ac4a275cee7bc8af601be4",
        "swapAddress": ""
    },
    // ELA
    "20":{
        "rpcUrl":"https://rpc.glidefinance.io",
        "scanUrl":"https://eth.elastos.io",
        "address": "",
        "swapAddress": ""
    },
    // CFXEVM
    "1030": {
        "rpcUrl":"https://evm.confluxrpc.com",
        "scanUrl":"https://evm.confluxscan.net/",
        "address": "",
        "swapAddress": ""
    },
    // SYSEVM
    "57":{
        "rpcUrl":"https://rpc.syscoin.org",
        "scanUrl":"https://explorer.syscoin.org",
        "address": "0x43e9f7ca4aeacd67a7ac4a275cee7bc8af601be4",
        "swapAddress": ""
    },
    // FEVM
    "314":{
        "rpcUrl":"https://rpc.ankr.com/filecoin",
        "scanUrl":"https://filscan.io",
        "address": "",
        "swapAddress": ""
    },
    // TELOSEVM
    "40": {
        "rpcUrl":"https://mainnet.telos.net/evm",
        "scanUrl":"https://www.teloscan.io/",
        "address": "",
        "swapAddress": ""
    },
    // ARB
    "42161":{
        "rpcUrl":"https://rpc.ankr.com/arbitrum",
        "scanUrl":"https://arbiscan.io",
        "address": "0xce9df9c81Cc893628E60165c6aF3c5C204ea60e2",
        "swapAddress": "0x88aCd533fD20Bc345f9afE640707f406b0e02552",
    },
    // OP
    "10":{
        "rpcUrl":"https://opt-mainnet.g.alchemy.com/v2/JzmIL4Q3jBj7it2duxLFeuCa9Wobmm7D",
        "scanUrl":"https://optimistic.etherscan.io",
        "address": "0x43e9f7ca4aeacd67a7ac4a275cee7bc8af601be4",
        "swapAddress": ""
    },
    // BASE
    "8453":{
        "rpcUrl":"https://base.llamarpc.com",
        "scanUrl":"https://basescan.org",
        "address": "0x43e9f7ca4aeacd67a7ac4a275cee7bc8af601be4",
        "swapAddress": ""
    },
    // LINEA
    "59144":{
        "rpcUrl":"https://rpc.linea.build",
        "scanUrl":"https://lineascan.build/",
        "address": "0x43e9f7ca4aeacd67a7ac4a275cee7bc8af601be4",
        "swapAddress": ""
    },
    // ZKEVM
    "1101":{
        "rpcUrl":"https://polygon-zkevm.blockpi.network/v1/rpc/public",
        "scanUrl":"https://zkevm.polygonscan.com",
        "address": "0x43e9f7ca4aeacd67a7ac4a275cee7bc8af601be4",
        "swapAddress": ""
    },
    // ZKSYNC
    "324":{
        "rpcUrl":"https://mainnet.era.zksync.io",
        "scanUrl":"https://www.oklink.com/cn/zksync",
        "address": "0x22a701a385f81155abab88311d99031c3ab26ca5",
        "swapAddress": ""
    },
    // OPBNB
    "204":{
        "rpcUrl":"https://opbnb.publicnode.com",
        "scanUrl":"https://opbnbscan.com",
        "address": "0x43e9f7ca4aeacd67a7ac4a275cee7bc8af601be4",
        "swapAddress": ""
    },
    // ROLLUX
    "570":{
        "rpcUrl":"https://rpc.rollux.com",
        "scanUrl":"https://explorer.rollux.com",
        "address": "0x43e9f7ca4aeacd67a7ac4a275cee7bc8af601be4",
        "swapAddress": ""
    },
    // CUBE
    "1818":{
        "rpcUrl":"https://http-mainnet-archive.cube.network",
        "scanUrl":"https://www.cubescan.network/en-us",
        "address": "",
        "swapAddress": ""
    },
    // SHIBA
    "109":{
        "rpcUrl":"https://www.shibrpc.com",
        "scanUrl":"https://www.shibariumscan.io",
        "address": "0x43e9f7ca4aeacd67a7ac4a275cee7bc8af601be4",
        "swapAddress": ""
    },
    // SCROLL
    "534352":{
        "rpcUrl":"https://scroll-mainnet.public.blastapi.io",
        "scanUrl":"https://blockscout.scroll.io/",
        "address": "0x43e9f7ca4aeacd67a7ac4a275cee7bc8af601be4",
        "swapAddress": ""
    },
    // MERLIN
    "4200":{
        "rpcUrl":"https://rpc.merlinchain.io",
        "scanUrl":"https://scan.merlinchain.io/",
        "address": "0x43e9f7ca4aeacd67a7ac4a275cee7bc8af601be4",
        "swapAddress": ""
    },
    // BLAST
    "81457": {
        "rpcUrl":"https://rpc.ankr.com/blast",
        "scanUrl":"https://blastscan.io/",
        "address": "0x43e9f7ca4aeacd67a7ac4a275cee7bc8af601be4",
        "swapAddress": ""
    }
}

export default chainRpcs